import type { RuntimeConfig } from './RuntimeConfig';

const RUNTIME_CONFIG_URL = '/_runtime-config';

export async function fetchRuntimeConfig(): Promise<RuntimeConfig> {
    const res = await fetch(RUNTIME_CONFIG_URL, { credentials: 'same-origin' });
    if (!res.ok) {
        throw new Error(`Failed to fetch runtime config (${res.status})`);
    }
    return (await res.json()) as RuntimeConfig;
}
